import { VehicleInstanceResource, VehicleSpecificationResource, VehicleDefinitionResource } from '../Api/Vehicle'
import { ValuationResource } from '../Api/Valuation'
import md5 from 'js-md5'
import Moment from 'moment';

const relations = [
    'tags', 'images', 'videos', 'vehicle.specifications', 'vehicle.providerSpecifications', 
    'vehicle.specifications.group', 'vehicle.providerSpecifications.group',
    'vehicle.valuations', 'purchaseCost', 'purchaseCost.expense.contact', 'owner', 'vehicle.registrations', 'vehicle.mileageLog',
    'location', 'location.salesTeam', 'expenseItems', 'expenseItems.expenseCategory',  'vehicle.instances',
    'vehicle.instances.purchaseCost', 'vehicle.instances.expense', 'vehicle.instances.purchaseCost.expense.contact',
    'vehicle.instances.relatedSalesInvoices.contact','vehicle.instances.relatedSalesInvoices.createdBy','vehicle.instances.createdBy',
    'expenseItems.expense', 'expenseItems.expense.contact',
     'deal', 'deal.salesPerson', 'deal.contact', 'deal.handoverBooking', '    deal.handoverLocation', 'deal.invoice',
    'reservation', 'reservation.contact', 'reservation.salesPerson', 'latestAutotraderActionLog',
    'partExchangeRecord', 'partExchangeRecord.deal', 'partExchangeRecord.deal.contact', 'warranty', 'servicePlan', 'advertisingChannels',
    'documents', 'documents.createdBy', 'vehicle.motTests', 'relatedSalesInvoices', 'relatedSalesInvoices.createdBy', 'relatedSalesInvoices.items.instance',
    'inspections', 'inspections.completedBy', 'historicRetailPrices', 'historicRetailPrices.createdBy', 'groups',
    'fundingRecord', 'financeSettlement', 'financeAgreement', 'physicalLocationAssociation',
];

const taskRelations = [
    'jobs', 'jobs.assignee', 'jobs.createdBy', 'jobs.team', 'jobs.instance', 'jobs.children',
    'jobs.parts', 'jobs.consumables', 'jobs.expenseItems', 'jobs.inspection', 'fundingRecord',
];

const activityRelations = [
    'activities',
];

export default {
    namespaced: true,
    state: {
        instance: null,
    },
    getters: {
        valuationDescription: state => {
            if (state.instance && state.instance.vehicle) {
                return {
                    vehicle_id: state.instance.vehicle.id,
                    vehicle_type: state.instance.vehicle.vehicle_type,
                    registration_date: state.instance.vehicle.registration_date,
                    specification_id: state.instance.vehicle.specification_id,
                    specification_driver: state.instance.vehicle.specification_driver,
                    manufacturer: state.instance.vehicle.manufacturer.name,
                    model: state.instance.vehicle.model.name,
                    derivative: state.instance.vehicle.derivative,
                    transmission_type: state.instance.vehicle.transmission_type,
                    body_type: state.instance.vehicle.body_type,
                    mileage: state.instance.vehicle.mileage,
                    vin: state.instance.vehicle.vin,
                    vrm: state.instance.vehicle.registration.vrm,
                    owners: state.instance.owners,
                };
            }
        },
        currentValiationHash: (state, getters) => {
            let descriptionObject = getters.valuationDescription;

            if (descriptionObject) {
                let description = _.toArray(descriptionObject);

                return md5(description.join('-'));
            }
        },
        hasValidValuation: (state, getters) => {
            if (state.instance && state.instance.vehicle) {
                let instanceHash = state.instance.vehicle.valuation_description_hash;

                return getters.currentValiationHash === instanceHash;
            }
        },
    },
    mutations: {
        set(state, instance) {
            state.instance = instance;
        },
        setVehicle(state, vehicle) {
            state.instance.vehicle = vehicle;
        },
        setVehicleSpecs(state, specs) {
            state.instance.vehicle.specifications = specs;
        },
        updateExpenses(state, expense) {
            // Remove all expense_items related to the expense.
           let expense_items = state.instance.expense_items.filter(
                cost => parseInt(cost.expense_id) !== parseInt(expense.id)
            );

            // Add the expenses expense_items.
            Vue.set(state.instance, 'expense_items', expense_items.concat(expense.items));
        },
        removeVehicleImage(state, image) {            
            state.instance.images = state.instance.images.filter(
                item => { return parseInt(item.id) !== parseInt(image.id) }
            );
        },
        createOrUpdateVehicleImage(state, image) {
            let index = state.instance.images.findIndex(
                item => { return parseInt(item.id) === parseInt(image.id); }
            )

            if (index > -1) {
                Vue.set(state.instance.images, index, image);
            } else {
                state.instance.images.push(image);
            }

            Vue.set(state.instance, 'images', state.instance.images.filter(item => { return true; }));
        },
        addValuation(state, valuation) {
            state.instance.vehicle.valuations.unshift(valuation);
        },
        addOrUpdateJob(state, job) {
            job.instance_id = state.instance.id;

            let index = state.instance.jobs.findIndex(item => { 
                return parseInt(item.id) === parseInt(job.id) 
            });

            if (index > -1) {
                Vue.set(state.instance.jobs, index, job);
            } else {
                state.instance.jobs.push(job);
            }
        },
        removeJob(state, job) {
            state.instance.job = state.instance.jobs.filter(item => {
                return item.id !== job.id;
            })
        },
        updateVehicleValuationHash(state, hash) {
            state.instance.vehicle.valuation_description_hash = hash;
        },
        setMotTests(state, tests) {
            state.instance.vehicle.mot_tests = tests;
        },
    },
    actions: {
        create(context, instance) {
            return new Promise((resolve, reject) => {
                VehicleInstanceResource.store(instance, { with: relations }).then(response => {
                    context.commit('set', response.data);
                    resolve(response.data);
                 }, error => { handleApiError(error, reject) })
            });
        },
        update(context, instance) {
            return new Promise((resolve, reject) => {
                VehicleInstanceResource.update(instance.id, instance, { with: relations }).then(response => {
                    context.commit('set', response.data);
                    resolve(response.data);
                }, error => { reject(); handleApiError(error); })
            });
        },
        load(context, id) {
            return new Promise((resolve, reject) => {
                VehicleInstanceResource.find(id, { with: relations }).then(response => {
                    let instance = context.state.instance ? context.state.instance : {}
                    context.commit('set', Object.assign(instance, response.data));

                    resolve(response.data);
                }, error => { reject(); handleApiError(error); })
            });
        },
        loadActivities(context, id) {
            return new Promise((resolve, reject) => {
                VehicleInstanceResource.find(id, { with: activityRelations }).then(response => {
                    let instance = context.state.instance;
                    Vue.set(instance, 'activities', response.data.activities);
                    context.commit('set', instance);

                    resolve(context.state.instance);
                }, error => { reject(); handleApiError(error); })
            });
        },
        loadJobs(context, id) {
            return new Promise((resolve, reject) => {
                VehicleInstanceResource.find(id, { with: taskRelations }).then(response => {
                    let instance = context.state.instance;
                    Vue.set(instance, 'jobs', response.data.jobs);
                    context.commit('set', instance);

                    resolve(context.state.instance);
                }, error => { reject(); handleApiError(error); })
            });
        },
        reload(context, id) {
            return new Promise((resolve, reject) => {
                context.dispatch('load', context.state.instance.id).then(response => {
                    context.dispatch('loadJobs', context.state.instance.id).then(response => {
                        resolve(response);
                    }, error => {
                        reject(error)
                    })
                }, error => {
                    reject(error);
                });
            });
        },
        syncVehicleSpecs(context) {
            return new Promise((resolve, reject) => {
                let resource = VehicleSpecificationResource.forVehicle(
                    context.state.instance.vehicle.id
                );

                let specifications = context.state.instance.vehicle.specifications;

                resource.store({ specifications }).then(response => {
                    resolve();
                }, error => { reject(); handleApiError(error); }); 
            });
        },
        refreshVehicleSpecs(context) {
            return new Promise((resolve, reject) => {
                let resource = VehicleDefinitionResource.refreshSpecification(
                    context.state.instance.vehicle.id
                ).then(response => {
                    context.dispatch('reload', context.state.instance.id)
                    resolve(response.data);
                }, error => { reject(); handleApiError(error); }); 
            });
        },
        refreshVehicleData(context) {
            return new Promise((resolve, reject) => {
                let resource = VehicleDefinitionResource.refreshVehicleData(
                    context.state.instance.vehicle.id
                ).then(response => {
                    context.dispatch('reload', context.state.instance.id)
                    resolve(response.data);
                }, error => { reject(); handleApiError(error); }); 
            });
        },
        uploadImage(context, payload) {
            return new Promise((resolve, reject) => {
                let resource = VehicleInstanceImageResource.forVehicle(
                    context.state.instance.id
                );

                let listener = payload.onprogress ? payload.onprogress : null;

                let uploadPromise = resource.upload(
                    payload.source, payload.type, payload.order, payload.id, listener
                );

                uploadPromise.then(response => {
                    context.commit('createOrUpdateVehicleImage', response.data);
                    resolve(response.data);
                }, error => { reject(); handleApiError(error); }); 
            });
        },
        destroyImage(context, image) {
            return new Promise((resolve, reject) => {
                let resource = VehicleInstanceImageResource.forVehicle(
                    context.state.instance.id
                );

                resource.destroy(image.id).then(response => {
                    context.commit('removeVehicleImage', image);
                    resolve(response.data);
                }, error => { reject(); handleApiError(error); }); 
            });
        },
        value(context) {
            return new Promise((resolve, reject) => {
                let id = context.state.instance.vehicle.id;
                let mileage = context.state.instance.vehicle.mileage;
                let description = context.getters.valuationDescription;

                ValuationResource.value(description, mileage).then((response) => {
                    if (!response.data.error) {
                        context.commit('addValuation', response.data);

                        context.commit(
                            'updateVehicleValuationHash', 
                            context.getters.currentValiationHash
                        );

                        resolve(response.data);
                    } else {
                        reject(response.data.error);
                    }
                }).catch(e => {
                    if (!e.response || e.response.status !== 404) {
                        reject();
                        handleApiError(e);
                    }
                });
            })
        },
    },
}